
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.857.5v9.286h8.572","stroke":"#000","stroke-linejoin":"bevel"}}),_c('mask',{attrs:{"id":"doc-sign_svg__a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.895 40.496H2.865L2.858.5h25.714l8.572 8.571V40.5l-2.565-.004"}})]),_c('path',{attrs:{"d":"M2.866 40.496h-1v1h1v-1zM2.857.5v-1h-1v1h1zm25.714 0l.707-.707-.292-.293h-.415v1zm8.572 8.571h1v-.414l-.293-.293-.707.707zm0 31.429l-.002 1 1.002.002V40.5h-1zm-2.248-1.004H2.865v2h32.03v-2zm-31.03 1L3.858.5h-2l.009 39.996h2zM2.858 1.5h25.714v-2H2.857v2zm25.007-.293l8.572 8.572 1.414-1.415-8.572-8.571-1.414 1.414zm8.279 7.864V40.5h2V9.071h-2zM37.144 39.5l-2.564-.004-.004 2 2.565.004.003-2z","fill":"#000","mask":"url(#doc-sign_svg__a)"}}),_c('path',{attrs:{"d":"M7.179 5.538h8.754M7.179 8.385h4.94M7.627 32.822l3.256-3.257M7.902 29.995l3.493 3.494M7.115 14.879l16.247-.187M7.115 19.086H31.56M7.142 34.666l25-.642","stroke":"#000","stroke-linejoin":"bevel"}}),_c('path',{attrs:{"d":"M32.142 32.059c-.833.257-1.944.883-2.752 1.425-.38.256-.758.513-1.06.655-.784.428-1.465.798-2.122.798-.328 0-.58-.114-.758-.342-.277-.399-.277-1.026-.177-1.824.076-.74 0-1.339-.201-1.624-.101-.142-.253-.2-.48-.17-.606.028-1.869 1.196-4.091 3.76l-1.364 1.596 1.768-5.328c.303-.912.076-1.881-.53-2.508-.48-.484-1.314-.77-2.197-.114l-1.87 1.425","stroke":"#478FFF","stroke-width":"2"}})])
          )
        }
      }
    